import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [remainingPosts, setRemainingPosts] = useState(0); // ✅ new state

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (!storedToken) return;

    setToken(storedToken);

    // Fetch fresh user from backend every time page loads
    fetch(`${process.env.REACT_APP_API_URL}/api/user/me`, {
      headers: { Authorization: `Bearer ${storedToken}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch user");
        return res.json();
      })
      .then((data) => {
        setUser(data);
        setRemainingPosts(data.remainingPosts || 0); // ✅ set remainingPosts
        localStorage.setItem("user", JSON.stringify(data)); // keep in sync
      })
      .catch((err) => {
        console.error("AuthContext: error fetching user", err);
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      });
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    setToken(token);
    setRemainingPosts(userData.remainingPosts || 0); // ✅ update remainingPosts
    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("token", token);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setRemainingPosts(0); // ✅ reset remainingPosts
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  // ✅ Consume one post (after successful post creation)
  const usePostCredit = () => {
    setRemainingPosts((prev) => (prev > 0 ? prev - 1 : 0));
  };

  // ✅ Add posts after payment
  const addPostCredits = (count) => {
    setRemainingPosts((prev) => prev + count);
  };

  return (
    <AuthContext.Provider
      value={{ user, token, remainingPosts, login, logout, usePostCredit, addPostCredits }}
    >
      {children}
    </AuthContext.Provider>
  );
};
